import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./root/App";

const mountEl = document.getElementById("mount");

if (mountEl) {
  createRoot(mountEl).render(React.createElement(App, null));
}
